import styled from 'styled-components'
import Window from 'loankeeper-common/components/Window'
import { loadFont } from 'loankeeper-common/helpers/styles'

import LKModal from './LKModal'
import LKModalContainer from './container'
import { CancelButton } from './LKModalButtons'
import LKModalTrigger from './LKModalTrigger'
import { useLKModal } from './LKModalContext'
import LKDobModal from './LKDobModal'
import LKErrorModal, { openError } from './LKErrorModal'
import LKInfoModal, { openInfo } from './LKInfoModal'
import LKConfirmationModal, { openConfirmation } from './LKConfirmationModal'

import reducer, { REDUCER_NAME } from './reducer'
import * as baseActions from './actions'
import * as selectors from './selectors'

export const actions = {
  ...baseActions,
  openError,
  openInfo,
  openConfirmation,
}

LKModal.Footer = styled(Window.Footer)`
  &.lk-window-footer {
    background-color: #2185d0;
    background-color: var(--color-modal-background-footer);

    *:not(i) {
      ${(props) => loadFont(props.theme.windowFooterFont)}
      color: var(--color-window-header-text);
    }

    .lk-window-footer__side-actions .lk-button {
      width: auto;
    }

    .ui.button {
      background-color: var(--color-modal-footer-action-button-background);

      :hover {
        background-color: var(--color-modal-footer-action-button-hover);
      }

      .lk-button-content {
        line-height: 100%;
        overflow: initial;
        color: var(--color-modal-footer-action-button-text);
      }
    }
  }
`

LKModal.CancelButton = CancelButton

LKModal.Confirmation = LKConfirmationModal
LKModal.Dob = LKDobModal
LKModal.Error = LKErrorModal
LKModal.Info = LKInfoModal

export { LKModalContainer, LKModalTrigger, reducer, REDUCER_NAME, selectors, useLKModal }

export default LKModal
